import React from 'react';

import { PRODUCT_SUPPORT_EMAIL } from '../constants/constants';
import { useTranslation } from 'react-i18next';

const DeleteAccount_en = () => {
  const { t } = useTranslation();

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
        <div style={{ width: '90%' }}>
          <br />
          <h4>DELETE ACCOUNT</h4>
          <p>
            <strong>
              If you need to delete your account, follow these steps:
            </strong>
          </p>
          <ol>
            <li>Open the Begin Bright mobile app and log in to your account</li>
            <li>Click on the person icon in the bottom right of the app.</li>
            <li>Click on the red Delete Account button.</li>
          </ol>
          <p>
            <strong>Please note:</strong> If you choose to delete your account, all data associated with your account — including your completion certificates — will be erased. This process is irreversible.
          </p>
          <p>
            <strong>Need Assistance?</strong> If you encounter any issues while trying to delete your account, feel free to contact us at <a href={"mailto:"+PRODUCT_SUPPORT_EMAIL}>{PRODUCT_SUPPORT_EMAIL}</a>.
          </p>
          <p>
            If you have questions regarding data privacy, please refer to our <a href='https://platform.beginbright.org/privacy_policy'>Privacy Policy</a>.
          </p>
        </div>
      </div>
    </>
  );
};

export default DeleteAccount_en;
